/**
 * Component for our Manual-Returns feature
 * ("Multichannel Return") that allows the user
 * to add a Product to the Manual-Return.
 * 
 * @component
 */

import React, { Component } from "react";
import { Form, Input, Row, Col, Select, Modal, message } from "antd";

const { Option } = Select;
const FormItem = Form.Item;
const { TextArea } = Input;

class ManualReturnProduct extends Component {
  constructor(props) {
    super(props);
    this.state = {
            
    };
  }

    handleCountryChange = (countryCode) => {
      this.setState({
        shippingCountryCode: countryCode,
      });
    };
    formRef = React.createRef(); // Create a ref for the form instance

    handleChange = () => {

    }

    handleSubmit = async () => {
      try {
        const values = await this.formRef.current.validateFields();
        this.props.addProduct(values);
        this.props.setModalAddProductVisible(false);
      } catch (err) {
        message.error("Error. Please check the data you entered.", 5);
      }
    };

    render() {
      return (
        <Modal
          title="Add product to return"
          centered
          visible={this.props.modalAddProductVisible}
          okText="Add"
          onOk={this.handleSubmit.bind(this)}
          onCancel={() => this.props.setModalAddProductVisible(false)}
        >
          <Form ref={this.formRef}>
    
            <Row type="flex" justify="start" align="top">
              <Col span={24}>
                <FormItem label="Product">
                  <Form.Item
                    name="selectedVariantId"
                    rules={[{ required: true, message: 'Please add a product to the return.' }]}
                  >
                    <Select
                      placeholder="Select a product"
                      onChange={this.handleChange.bind(this)}
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {this.props.products}
                    </Select>
                  </Form.Item>
                </FormItem>
              </Col>
            </Row>
    
            <Row type="flex" justify="start" align="top">
              <Col span={24}>
                <FormItem label="Resolution">
                  <Form.Item
                    name="selectedResolution"
                    rules={[{ required: true, message: 'Please select a resolution.' }]}
                  >
                    <Select>
                      <Option value="refundToExchange">Exchange</Option>
                      <Option value="refundToOriginal">Refund</Option>
                    </Select>
                  </Form.Item>
                </FormItem>
              </Col>
            </Row>
    
            <Row type="flex" justify="start" align="top">
              <Col span={24}>
                <FormItem label="Return reason">
                  <Form.Item
                    name="selectedReturnReason"
                    rules={[{ required: true, message: 'Please add a reason for return.' }]}
                  >
                    <Select
                      onChange={this.handleChange.bind(this)}
                      placeholder="Select a return reason"
                    >
                      {this.props.returnReasonsElements}
                    </Select>
                  </Form.Item>
                </FormItem>
              </Col>
            </Row>
    
            <Row type="flex" justify="start" align="top">
              <Col span={24}>
                <FormItem label="Notes">
                  <Form.Item name="notes">
                    <TextArea
                      rows={3}
                      placeholder="Optional notes in relation to the product being returned or exchange item."
                    />
                  </Form.Item>
                </FormItem>
              </Col>
            </Row>
    
          </Form>
        </Modal>
      )
    }
    
}
export default ManualReturnProduct;